// Which past-images pricelist sells a given past photo.
//
// ONE implementation, because the rule is not obvious from the data: a
// past-images pricelist's `season` is a season TYPE with no year on it
// ('fall', 'spring', 'grad', 'seniors'), while a student_image's `folder`
// carries the year ('fall2026'). The match is therefore a substring test, not
// an equality one -- comparing them with === silently sells nothing at all.
//
// Used by the LEGACY prior-season pitch (PastImageItems) and nothing else.
//
// ⚠️ NOT what "View Packages" opens any more (2026-10-14). That link now goes to
// THIS YEAR'S pricelist for the photo's kind of picture, decided server-side and
// carried on the image as `currentTypePackageId` -- an old photograph bought at
// today's prices. This substring match is also why a "sportsfall2026" team photo
// used to open "Fall Past Images": the folder contains "fall". The legacy pitch
// still uses it because its card composites a preview over this pricelist's
// `defaultBackgroundUrl`; converging the two is a separate change.
export default function pastImagesPricelistFor(studentImage, pricelists) {
  const folder = studentImage && studentImage.folder;
  if (!folder) return null;

  return (pricelists || []).find((pricelist) => (
    pricelist && pricelist.season && folder.includes(pricelist.season)
  )) || null;
}
